<p-button
  class="p-button-sm"
  [text]="true"
  [outlined]="true"
  [ngClass]="{ 'btn-active': isSelectionChange() }"
  [icon]="isSelectionChange() ? 'icon-plus-circle-solid' : 'icon-plus-circle'"
  (onClick)="op.toggle($event)"
>
</p-button>

<p-popover
  #op
  [styleClass]="'multi-select-overlayPanel'"
>
  <p-orderList
    [className]="'multi-select-order-list'"
    [value]="items()"
    [listStyle]="{ height: '14rem' }"
    [dragdrop]="true"
  >
    <ng-template
      let-item
      pTemplate="item"
    >
      <div class="flex align-items-center gap-3">
        <p-checkbox
          [(ngModel)]="selectedItem"
          [inputId]="item[optionLabel()]"
          name="region"
          [value]="item"
          (onChange)="selectionChange()"
        />
        <label
          [for]="item[optionLabel()]"
          class="flex-1"
          >{{ item[optionLabel()] }}</label
        >
        <em class="icon-dots-six-vertical ml-auto"></em>
      </div>
    </ng-template>
  </p-orderList>
</p-popover>
